import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n, loadLanguageAsync } from './i18n-setup'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import PlatformFilter from './utils/platform.filter'
import DateFilter from './utils/date.filter'
import CurrencyFilter from './utils/currency.filter'

Vue.config.productionTip = false

Vue.filter('platform', PlatformFilter)
Vue.filter('date', DateFilter)
Vue.filter('currency', CurrencyFilter)

Vue.use(Loading)

// Check authentication before each page load
router.beforeEach((to, from, next) => {
  loadLanguageAsync(store.state.language.activeLanguage)
    .then(() => {
      document.title = to.meta.title

      if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!sessionStorage.getItem('token')) {
          next({
            name: 'login',
            query: { redirect: to.fullPath }
          })
        } else {
          next()
        }
      } else {
        next() // make sure to always call next()!
      }
    })
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
